import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "TwoColumnGrid",
    component: () => (__SERVER__ ? require("./two-column-grid-view") : import("./two-column-grid-view"))
});

export default definition;
